import { mount } from 'svelte';
import ChapterReactions from '../components/Reactions.svelte';
import type { ReactionableType } from '@components/reactions/types';

document.addEventListener('DOMContentLoaded', (): void => {
  const reactionsContainer = document.getElementById('reactions-component');
  if (reactionsContainer) {
    const { reactionableType, reactionableId } = reactionsContainer.dataset;

    mount(ChapterReactions, {
      target: reactionsContainer,
      props: {
        reactionableType: reactionableType as ReactionableType,
        reactionableId: reactionableId as string,
      },
    });
  }
});
